import { render, staticRenderFns } from "./DeleteGoodsModal.vue?vue&type=template&id=c70b745e&"
import script from "./DeleteGoodsModal.vue?vue&type=script&lang=js&"
export * from "./DeleteGoodsModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteGoodsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports